import { Box, Button, Container, TextField, Typography, Autocomplete } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import Loading from './Loading';
import { useFindUsersByCategoryMutation } from '../store/api/userApi';
import { useSaveNotesDetailsMutation } from '../store/api/notesApi';

type Props = {};

const NotesSchema = Yup.object().shape({
  description: Yup.string().required('This field is required'),
});

const ResponsiveBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const FormikBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    marginLeft: '0px',
  },
  [theme.breakpoints.up('md')]: {
    marginLeft: '20px',
  },
}));

const AddNotes = (props: Props) => {
  const { state }: any = useLocation();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    description: '',
    emailId: '',
  });
  const token = JSON.parse(localStorage.getItem('login') || '{}').token;
  const [saveOfferDetail, saveOfferDetailResponse] = useSaveNotesDetailsMutation();
  const [email, setEmail] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState(state?.name) as any;
  const [getAllEmail, EmailResponse] = useFindUsersByCategoryMutation();
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [value, setValue] = useState(null);

  const validate = (values: any) => {
    const errors: any = {};
    if (value == null || value == '' || value == undefined) errors['emailId'] = 'This field is required';
    return errors;
  };

  const handleAddNotes = (values: any, action: any) => {
    saveOfferDetail({
      token: token,
      payload: {
        description: values.description,
        userId: selectedOptions?.id,
      },
    });
  };

  useEffect(() => {
    if (saveOfferDetailResponse.isSuccess) {
      toast.success('Note added successfully');
      navigate('/dashboard/notes', { replace: true });
    } else if (saveOfferDetailResponse.isError) {
      let errorData: any = saveOfferDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [saveOfferDetailResponse.isSuccess, saveOfferDetailResponse.isError]);

  const selectItems = (option: any) => {
    if (option !== null && option !== undefined) {
      setSelectedOptions(option);
    }
  };

  const selectServiceProvider = (value: any) => {
    getAllEmail({
      token: token,
      payload: {
        offset: rowsPerPage,
        page: page,
        searchValue: value,
        userCategory: ['UTSP', 'UTCUST'],
      },
    });
  };

  useEffect(() => {
    if (EmailResponse.isSuccess) {
      setEmail(EmailResponse.data.data);
    }
  }, [EmailResponse.isSuccess]);

  return (
    <Box>
      <Container>
        <h1>Add Notes</h1>
        <ResponsiveBox style={{ display: 'flex', paddingTop: '40px' }}>
          <FormikBox style={{ flex: 1, padding: 0 }}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={handleAddNotes}
              validationSchema={NotesSchema}
              validate={validate}
            >
              {({ handleBlur, handleChange, handleSubmit, touched, errors }) => (
                <Box style={{ width: '100%' }}>
                  <Box marginTop={'25px'}>
                    <Typography id="emailId" variant="h5" marginTop={2} gutterBottom component="div">
                      Email
                    </Typography>
                    <Autocomplete
                      id="emailId"
                      options={email}
                      value={state.name}
                      getOptionLabel={(item: any) => (item.email ? `${item.email}` : '')}
                      style={{ width: '100%', marginTop: '30px' }}
                      renderInput={(params) => (
                        <TextField {...params} label="Enter user email id" variant="outlined" required />
                      )}
                      onChange={(event: any, value: any) => {
                        if (value !== null && value !== '') {
                          selectItems(value);
                        }
                      }}
                      onInputChange={(event: any, value: any) => {
                        setValue(value);
                        if (value !== null && value !== '' && value.length >= 3) {
                          selectServiceProvider(value);
                        }
                      }}
                      clearOnBlur={false}
                      clearOnEscape={false}
                      onBlur={handleBlur}
                    />
                    {errors.emailId && <div style={{ color: 'red' }}>{errors.emailId}</div>}
                  </Box>
                  <Box style={{ width: '100%' }}>
                    <Typography variant="h5" marginTop={2} gutterBottom component="div">
                      Description
                    </Typography>
                    <TextField
                      type="description"
                      id="description"
                      name="description"
                      label="Enter description"
                      multiline
                      rows={6}
                      style={{ width: '100%' }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.description && errors.description)}
                      helperText={touched.description && errors.description}
                    />
                  </Box>
                  <Box style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                      style={{ color: 'white', backgroundColor: '#E23744' }}
                      variant="contained"
                      onClick={() => {
                        navigate('/dashboard/notes');
                      }}
                      sx={{ marginRight: '10px' }}
                      size="large"
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ color: 'white', backgroundColor: '#E23744' }}
                      variant="contained"
                      size="large"
                      component="span"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              )}
            </Formik>
          </FormikBox>
        </ResponsiveBox>
      </Container>
      {saveOfferDetailResponse.isLoading || EmailResponse.isLoading ? <Loading /> : null}
    </Box>
  );
};

export default AddNotes;
